<template>
    <v-btn
        v-if="pfHrefInfo"
        class="svg-icon"
        icon
        @click="openInNewTab(getClientRefFromParsed(pfHrefInfo))"
        :style="`width:${btnWidth}px;height:${btnHeight}px`"
    >
        <v-icon :size="size" color="mainNew">{{ '$vuetify.icons.profSalon' }}</v-icon></v-btn
    >
</template>
<script>
import { openInNewTab } from '@root/src/utils'
import { getClientRefFromParsed } from '../chisai/getClientsBack/helpers'
import { CONNECTOR_TYPES } from '@root/src/vars/general'
export default {
    name: 'WhatsappLink',
    components: {},
    props: {
        hrefInfo: {
            type: Array,
            default: () => [],
        },
        size: {
            type: Number,
            default: 18,
        },
        btnWidth: {
            type: Number,
            default: 36,
        },
        btnHeight: {
            type: Number,
            default: 36,
        },
    },
    data: () => ({}),
    computed: {
        pfHrefInfo() {
            return (
                this?.hrefInfo?.find(el => el.connectorType === CONNECTOR_TYPES.profSalon) ??
                this?.hrefInfo?.find(el => el.connectorType === CONNECTOR_TYPES.profSalonBat)
            )
        },
    },
    methods: { openInNewTab, getClientRefFromParsed },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
</style>
